import { profileTextField, withError } from '../../forms/newFields';
import React from 'react';

export function PureTextField({ label, mandatory, meta, input, ...props }) {
  return (
    <div className="scope-field-container">
      <div className="scope-field-label">
        {label}
        {mandatory && ' *'}
      </div>
      {withError(profileTextField)({ meta, input, ...props })}
    </div>
  );
}

/* <Props>
   name,
   label,
   mandatory,
   disabled,
   placeholder
 */
